export type CounterFnI = () => CounterI;

export interface CounterI {
  increment: (value: number) => void;
  decrement: (value: number) => void;
  get: () => number;
  clear: () => void;
}

export const counter: CounterFnI = () => {
  let count = 0;
  return {
    increment: (value: number = 1) => count += value,
    decrement: (value: number = 1) => count -= value,
    get: () => count,
    clear: () => count = 0,
  };
};
